export enum OrderStatus {
  AWAITING_PAYMENT = "awaiting-payment",
  PENDING = "pending",
  PAID = "paid",
  PACKAGED = "packaged",
  ENROUTE = "en-route",
  DELIVERED = "delivered",
  FAILED = "failed",
  CANCELLED = "cancelled",
}
